import { render, staticRenderFns } from "./siteAdminList.vue?vue&type=template&id=00ce5537&scoped=true&"
import script from "./siteAdminList.vue?vue&type=script&lang=js&"
export * from "./siteAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce5537",
  null
  
)

export default component.exports